import { TwinTranslationTF } from '../../hooks/useTwinTranslation';
import { TwinDictionary } from '../dictionary';
import { InputTableLayoutData } from '../../../baseComponents/TwinTable/InputTableLayout/types';
import { BuyOrderTypeShippingInversed } from '@teinor/erp/types/company/order/buy/buyOrder';
import { getConfigParam, getUserPermissions } from '../../reducers/getters';
import { checkIfUniqueNumbersAreOkey } from '../product/uniqueNumber';
import { TwinParameters } from '@teinor/erp/types/company/config/parameter';
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function';

export const notHaveCountersAndWarehousesWorkingCenter = (items: TwinDictionary) => {
    for (const key in items) {
        const item = items[key]
        items[key] = { ...item, is_blocked: !(item.WorkingCenterCounters?.length > 0 && item.Warehouses.length > 0) }
    }
    return items
}

const getBuyOrderShippingInfoMessage = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    const buyShippingByDefault = getConfigParam('buyShippingMandatory')
    if ((orderData.header.typeShipping === null || orderData.header.typeShipping === '') && (!buyShippingByDefault || buyShippingByDefault === 'on')) {
        return t('mustHaveShipping', 'Debes seleccionar tipo de envío para continuar') 
    } else if (orderData.header.typeShipping && !orderData.header?.OrderShippingId && !orderData.header?.OrderShipping?.id && (!orderData.header.typeShipping || parseInt(orderData.header.typeShipping) === BuyOrderTypeShippingInversed['sendToCustomer'])) {
        return t('mustHaveShippingToContinue', 'Debes seleccionar un transporte para continuar')
    }
    return null
}

const checkHaveProductsLength = (originalTableData: { [fieldName: string]: any; }[] | undefined, t: TwinTranslationTF) => {
    return originalTableData?.length ? null : t('mustAddProducts', 'Debes añadir productos para continuar')
}

export const checkBuyDeliveryNoteFromOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkBuyOrderDraftAllOk(orderData, t)
        if (result) {
            return result
        }
        const userPermission = getUserPermissions('buy.deliveryNote')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateBuyDeliveryNote', 'No tienes permisos para crear un albarán de compra')
        }
        const buyToFinished = getConfigParam('buyToDeliveryNoteFinished') as TwinParameters['buyToDeliveryNoteFinished']
        const nextStepFinished = buyToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getBuyOrderShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfUniqueNumbersAreOkey(orderData, t)
            if (result) {
                return result
            }
        }
    }
}
export const checkBuyInvoiceFromOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkBuyOrderDraftAllOk(orderData, t)
        if (result) {
            return result
        }
        const userPermission = getUserPermissions('buy.invoice')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateBuyInvoice', 'No tienes permisos para crear una factura de compra')
        }
        const buyToFinished = getConfigParam('buyToInvoiceFinished') as TwinParameters['buyToDeliveryNoteFinished']
        const nextStepFinished = buyToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getBuyOrderShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfUniqueNumbersAreOkey(orderData, t)
            if (result) {
                return result
            }
            const header = orderData?.header
            if (header?.supplier_assigned_number === '' || header?.supplier_assigned_number === null) {
                return t('notBillOrderWithOutSupplierAssignedNumber', 'No puedes facturar el pedido sin introducir el número de factura del proveedor')
            } else if ((header?.supplier_date === null || header?.supplier_date === '') || (header?.processed_date === null || header?.processed_date === '')) {
                return t('notBillOrderWithOutSupplierProcessedDate', 'No puedes facturar el pedido sin introducir la fecha de la factura del proveedor')
            }
        }
    }
}

export const checkBuyOrderDraftAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF, type?: 'deliveryNote' | 'invoice') => {
    if (orderData) {
        let result = checkHaveProductsLength(orderData.originalTableData, t)
        if (result) {
            return result
        }
        result = checkIfUniqueNumbersAreOkey(orderData, t)
        if (result) {
            return result
        }
    }
    return null
}

const checkIfInvoiceReady = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    let error: null | string = null;
    const header = orderData?.header
    if (header?.supplier_assigned_number === '' || header?.supplier_assigned_number === null) {
        error = t('notBillInvoiceWithOutSupplierAssignedNumber', 'No puedes cerrar la factura sin introducir el número de factura del proveedor')
    } else if ((header?.supplier_date === null || header?.supplier_date === '') || (header?.processed_date === null || header?.processed_date === '')) {
        error = t('notBillInvoiceWithOutSupplierProcessedDate', 'No puedes cerrar la factura sin introducir la fecha de la factura del proveedor')
    }
    return error
}
const checkIfDeliveryNoteReadyToInvoiceFinished = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    let error: null | string = null;
    const header = orderData?.header
    if (header?.supplier_assigned_number === '' || header?.supplier_assigned_number === null) {
        error = t('notProcessDeliveryNoteAutoWithOutSupplierAssignedNumber', 'No puedes procesar el albarán a factura finalizada sin introducir el número de factura del proveedor')
    } else if ((header?.supplier_date === null || header?.supplier_date === '') || (header?.processed_date === null || header?.processed_date === '')) {
        error = t('notProcessDeliveryNoteAutoWithOutSupplierProcessedDate', 'No puedes procesar el albarán a factura finalizada sin introducir la fecha de la factura del proveedor')
    }
    return error
}
export const checkBuyDeliveryNoteAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkHaveProductsLength(orderData.originalTableData, t)
        if (result) {
            return result
        }
        result = checkIfUniqueNumbersAreOkey(orderData, t)
        if (result) {
            return result
        }
        result = getBuyOrderShippingInfoMessage(orderData, t)
        if (result) {
            return result
        }
        const userPermission = getUserPermissions('buy.invoice')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateBuyInvoice', 'No tienes permisos para crear una factura de compra')
        }
        const buyDeliveryNoteToInvoiceFinished = getConfigParam('buyDeliveryNoteToInvoiceFinished') as TwinParameters['buyDeliveryNoteToInvoiceFinished']
        if (buyDeliveryNoteToInvoiceFinished === 'on'){
            result = checkIfDeliveryNoteReadyToInvoiceFinished(orderData, t)
            if(result){
                return result
            }
        }
    }
}


export const checkBuyInvoiceAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkHaveProductsLength(orderData.originalTableData, t)
        if (result) {
            return result
        }
        result = checkIfUniqueNumbersAreOkey(orderData, t)
        if (result) {
            return result
        }
        result = getBuyOrderShippingInfoMessage(orderData, t)
        if (result) {
            return result
        }
        result = checkIfInvoiceReady(orderData, t)
        if (result) {
            return result
        }
    }
}